module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibSetting-box"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('itable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "handle": _vm.handle,
      "page": _vm.page,
      "multiLanguage": _vm.multiLanguage,
      "sort": _vm.sort,
      "seekDropdown": _vm.seekDropdown,
      "selPage": _vm.selPage,
      "region": _vm.curArea,
      "isSetting": _vm.isSetting,
      "ibSpecialType": _vm.ibSpecialType,
      "ibc": _vm.ibc,
      "modifyTime": _vm.modifyTime,
      "confirmTime": _vm.confirmTime,
      "templateSel": _vm.templateSel,
      "ibTemplate": _vm.ibTemplate
    },
    on: {
      "update:ibc": function($event) {
        _vm.ibc = $event
      },
      "update:modifyTime": function($event) {
        _vm.modifyTime = $event
      },
      "update:modify-time": function($event) {
        _vm.modifyTime = $event
      },
      "update:confirmTime": function($event) {
        _vm.confirmTime = $event
      },
      "update:confirm-time": function($event) {
        _vm.confirmTime = $event
      },
      "tableChange": _vm.tableAjax,
      "downLoadExcelFn": _vm.excelDown,
      "seek": _vm.tableAjax
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b6c7fd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBSetting/ibSettingView.vue
// module id = 1115
// module chunks = 1